import * as dto from 'client/dto';

export const getNestingDisclaimerText = (locationType: dto.LocationType) => {
  switch (locationType) {
    case dto.LocationType.Country:
      return 'Number of cases based on the sum across provinces/states within the country.';
    case dto.LocationType.Province:
      return 'Number of cases based on the sum across metropolitan area within the province/state.';
    case dto.LocationType.MetroArea:
      return 'Number of cases based on the sum across counties within the metropolitan area.';
    case dto.LocationType.County:
      return 'Number of cases based on the sum across cities within the county.';
    default:
      return '';
  }
};
